/**
 * @generated SignedSource<<f9e2c9bba522434b2de51f7af3379e0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublicTemplate_query$data = {
  readonly company: {
    readonly features: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"HeaderLogo_company">;
  } | null | undefined;
  readonly me: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "PublicTemplate_query";
};
export type PublicTemplate_query$key = {
  readonly " $data"?: PublicTemplate_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublicTemplate_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublicTemplate_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Candidate",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeaderLogo_company"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "features",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "d6e253da9c7ac91f8cb2fc4d4e041f4b";

export default node;
